var cartSamples = {

    addedSamples: {},
    sampleSelector: 'variant_id',
    limits: [],
    maxSamples: 0,
    selectedSamples: 0,
    selector: '.cart-samples-section',

    init: function() {

        // if dip/coll customer is present we hide interface and reset everything
        if(customerNoPh != null && customerNoPh){
            this.hideInteface();
            this.addedSamples = {};
            this.removeExtraSamples();
            this.updateCartSamplesItem();
        }

        if (typeof window.cartSampleLimits === 'object') {
            this.limits = window.cartSampleLimits;
        }
        this.checkCart();
        this.addListeners();
    },

    checkCart: function() {
        var self = this;
        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function (cart) {
                if(cart.total_price > 0){
                    self.checkLimits(cart);
                    self.restoreAddedSamples();
                } else if(cart.total_price == 0){
                    self.addedSamples = {};
                    self.hideInteface();
                }

                //If a customer deletes the sample from the list, the addedSample list is updated
                self.updateRemovedSamples(cart.items);
                self.removeExtraSamples();
                self.updateSamplesSelectable();
            }
        });
    },

    checkLimits: function (cart) {

        var self = this,
            cartItems = cart.items,
            cartTotal = cart.total_price / 100;

        if(self.limits.length == 0) return;
        self.limits.sort((a, b) => parseFloat(a.min_price) - parseFloat(b.min_price));

        // Find the max minimum cart
        for(i in self.limits){
            var limit = self.limits[i];

            if (cartTotal >= limit.min_price ) {
                // Set the max samples
                self.updateSampleLimit(limit.max_samples);
            }
        }

    },

    restoreAddedSamples: function() { // check if there are already samples in cart
        const self = this;
        if (localStorage.getItem('addedSamples') !== null) {
            self.addedSamples = JSON.parse(localStorage.getItem('addedSamples'));
        }

        // Update internal limit counter
        self.updateSelectedSamples();

        // Reset all inputs
        document.querySelectorAll(`.samples_list input[data-${self.sampleSelector}]`).forEach( resetInput =>{
            resetInput.checked = false;
        });

        if (Object.entries(self.addedSamples).length > 0) {

            for (const [key, value] of Object.entries(self.addedSamples)) {
                const input = document.querySelectorAll(`.samples_list input[data-${self.sampleSelector}="${key}"]`);
                // Check the inputs relative to the stored samples
                if(input.length) input[0].checked = true;
            }
        }
    },

    addListeners: function() {
        var self = this,
            samples = document.querySelectorAll('.samples_list li input');
        for (let i = 0; i < samples.length; i ++) {
            samples[i].addEventListener('change', (event) => {
                const   sampleSku = samples[i].getAttribute(`data-${self.sampleSelector}`),
                        sampleTitle = samples[i].getAttribute('product_title');
                if( event.target.checked == true ){
                    self.addedSamples[sampleSku] = 1;
                    //Method needs to be called AFTER sample add so the API call can add the existing values
                    self.updateCartSamplesItem();
                } else {
                    //Method needs to be called BEFORE sample removal so the API call can update the value as 0
                    self.addedSamples[sampleSku] = 0;
                    self.updateCartSamplesItem();
                    delete self.addedSamples[sampleSku];
                }
                self.updateSelectedSamples();
                self.updateSamplesSelectable();
            });
        }

    },

    /* -- REMOVE COMMENTS IN ORDER TO USE CART NOTES AND SKU -- */
    // updateCartNotes: function() {
    //     var self = this;
    //     var cartNotes = '';

    //     //create note with key=id and value=name
    //     for (key of Object.keys(self.addedSamples)) {
    //         cartNotes += `${key}|`;
    //     }
    //     cartNotes = (cartNotes != '') ? `s:${cartNotes.slice(0, cartNotes.lastIndexOf("|"))}` : '';

    //     $.ajax({
    //         url: '/cart/update.js',
    //         method: 'POST',
    //         dataType: "json",
    //         data: {note: cartNotes},
    //         success: function(result) {
    //           sessionStorage.setItem('addedSamples', JSON.stringify(self.addedSamples));
    //         },
    //         error: function(jqxhr, status, exception) {
    //             console.log(exception);
    //         }
    //     });
    // },

    updateCartSamplesItem: function() {
        var self = this;

        $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            dataType: "json",
            data: {updates: self.addedSamples },
            success: function(result) {
              localStorage.setItem('addedSamples', JSON.stringify(self.addedSamples));
              location.reload();
            },
            error: function(jqxhr, status, exception) {
                console.log(exception);
            }
        });
    },

    updateSelectedSamples: function() {
        const self = this;
        self.selectedSamples = Object.entries(this.addedSamples).length;
        document.querySelectorAll(`.cartSampleCounter`).forEach( counter =>{
            counter.innerHTML = self.selectedSamples;
        });
        document.querySelectorAll(`.cartSampleCounterMax`).forEach( counter =>{
            counter.innerHTML = self.maxSamples;
        });
    },

    updateSamplesSelectable: function(){

            const self = this;

            document.querySelectorAll(`.samples_list input[data-${self.sampleSelector}]:not(:checked)`).forEach( disableInput =>{
                if(self.selectedSamples == self.maxSamples){
                    disableInput.setAttribute('disabled','disabled');
                } else {
                    disableInput.removeAttribute('disabled');
                }
            });

    },

    removeExtraSamples: function() {
        var self = this;
        let counter = 0;
        for (const [key, value] of Object.entries(self.addedSamples)) {
            counter += 1;
            if(counter > self.maxSamples){
                delete self.addedSamples[key];
            }
        }

        localStorage.setItem('addedSamples', JSON.stringify(self.addedSamples));
        self.restoreAddedSamples();
    },

    updateRemovedSamples: function(cart) {
        let cart_product_ids = cart.map(el => el.id.toString());

        for (key of Object.keys(this.addedSamples)) {
            if(!cart_product_ids.includes(key)){
                delete this.addedSamples[key];
            }
        }
    },

    updateSampleLimit: function (limit) {
        this.maxSamples = limit;
    },
    hideInteface: function(){
        const section = document.querySelector(this.selector);
        if(section != null) section.remove();
    }
}